import { useState, useCallback } from 'react';
import Validator from '@dragonfruit/utils/validator';

export function useValidateField() {
  const [value, setValue] = useState(null);
  const [isValidate, setIsValidate] = useState(true);

  const onChange = useCallback(value => {
    setValue(value);
  }, []);

  const onValidate = useCallback(() => {
    const validate = new Validator(value).isEmpty();
    setIsValidate(!validate.haveError());
  }, [value]);

  return [value, isValidate, onChange, onValidate];
}



// WEBPACK FOOTER //
// ./app/hooks/fieldsValidation.js